export default __webpack_public_path__ + "static/media/voucher_red.1f36a6ab.svg";